export default __webpack_public_path__ + "static/media/Rectangle 1.e7c61bd8.png";